import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const UpdatePluginCapabilitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePluginCapabilities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"capabilities"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePlugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fields"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"capabilities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"capabilities"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"capabilities"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"UpdatePluginCapabilities","document":UpdatePluginCapabilitiesDocument}} as const;
export type UpdatePluginCapabilitiesMutationVariables = Types.Exact<{
  capabilities?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  idPlugin: Types.Scalars['ID']['input'];
}>;


export type UpdatePluginCapabilitiesMutation = (
  { __typename: 'Mutation' }
  & { updatePlugin?: Types.Maybe<(
    { __typename: 'Plugin' }
    & Pick<Types.Plugin, 'id' | 'capabilities'>
  )> }
);

export type UpdatePluginCapabilitiesMutationFn = Apollo.MutationFunction<
  UpdatePluginCapabilitiesMutation,
  UpdatePluginCapabilitiesMutationVariables
>;

/**
 * __useUpdatePluginCapabilitiesMutation__
 *
 * To run a mutation, you first call `useUpdatePluginCapabilitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePluginCapabilitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePluginCapabilitiesMutation, { data, loading, error }] = useUpdatePluginCapabilitiesMutation({
 *   variables: {
 *      capabilities: // value for 'capabilities'
 *      idPlugin: // value for 'idPlugin'
 *   },
 * });
 */
export function useUpdatePluginCapabilitiesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePluginCapabilitiesMutation,
    UpdatePluginCapabilitiesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePluginCapabilitiesMutation,
    UpdatePluginCapabilitiesMutationVariables
  >(UpdatePluginCapabilitiesDocument, options);
}
export type UpdatePluginCapabilitiesMutationHookResult = ReturnType<
  typeof useUpdatePluginCapabilitiesMutation
>;
export type UpdatePluginCapabilitiesMutationResult =
  Apollo.MutationResult<UpdatePluginCapabilitiesMutation>;
export type UpdatePluginCapabilitiesMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePluginCapabilitiesMutation,
    UpdatePluginCapabilitiesMutationVariables
  >;
